<template>
<li class="hw_stat__train">
  <div class="hw_stat__content">
    <div class="hw_stat__title">
      <span>
        {{ item.homework.template.trainer ? item.homework.template.trainer.title : item.homework.template.params.title }}
      </span>

			<div class="homework-menu">
				<span class="uk-badge" uk-tooltip="Количество повторов">{{ item.homework.template.qnt }}</span>
      	<div class="hw_stat__stexpand" v-show="item.statistic.length > 0" @click="show_stat = !show_stat" uk-tooltip="Раскрыть статистику"></div>
      	<div class="is_done" :class="item.is_done ? 'true' : 'false'" :uk-tooltip="item.is_done ? 'Выполнено' : 'Не выполнено'"></div>
			</div>
    </div>
    <TrainerInfo :trainer="item.homework.template.trainer" :params="item.homework.template.params" />
  </div>

  <ul class="hw_stat__stats" v-show="show_stat">
    <li v-for="st in item.statistic" :key="st.id">
      <span>Ошибок: <i class="uk-badge uk-badge--err">{{ st.errors }}</i></span>
      <span>Баллов набрано: <i class="uk-badge">{{ st.scores }}</i></span>
      <span>Время выполнения:
        <i class="uk-badge" v-if="st.time">
          {{ st.time.minutes }} минут {{ st.time.seconds }} секунд
        </i>
        <i class="uk-badge" v-else>
          {{ sumTime(st.exercises)}}
        </i>
      </span>
    </li>
  </ul>
</li>
</template>

<script>
import TrainerInfo from '../trainer/TrainerInfo.vue'
import moment from "moment";

export default {
  name: "hw_stat_item",
	components: {TrainerInfo},
  data() {
    return {
      show_stat: false
    }
  },
  props: {
    item: ''
  },
  methods: {
    /** Split */
    split(str, razd) {
      return str.split(razd);
    },
    /** Возвращаем дробное число */
    isInt(val) {
      if (Number.isInteger(val)) {
        return val + '.0';
      } else {
        return val;
      }
    },
    /** Подсчет времени */
    sumTime(arr) {
      let allTime = _.reduce(arr, function (sum, n) {
        return sum + (n.timer.total_ms ? n.timer.total_ms : 0);
      }, 0);
      let dur = moment.utc(moment.duration(allTime).asMilliseconds()).format("mm:ss");
      return dur;
    }
  }
}
</script>

<style lang="scss" scoped>
.hw_stat__content {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.homework-menu {
	display: flex;
	flex-shrink: 0;
	align-items: center;
}
</style>
